const partners = [
  {
    icon: 'ri-cpu-line',
    title: 'Manufacturers',
    desc: 'Showcase your solar panels, batteries, inverters, EV chargers and energy products to qualified customers actively searching the marketplace.',
    color: 'bg-primary-50',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-500',
  },
  {
    icon: 'ri-tools-line',
    title: 'Installers',
    desc: 'Receive better-qualified enquiries from customers ready to proceed. Build your reputation through verified reviews and transparent ratings.',
    color: 'bg-accent-50',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-500',
  },
  {
    icon: 'ri-bank-line',
    title: 'Finance Providers',
    desc: 'Connect with homeowners and businesses actively seeking green loans, solar finance and renewable energy funding solutions.',
    color: 'bg-secondary-50',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-500',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Energy Retailers & VPP Operators',
    desc: 'Prepare for the distributed energy future. Connect with battery-equipped Australian households ready for virtual power plant participation.',
    color: 'bg-foreground-50',
    iconBg: 'bg-foreground-100',
    iconColor: 'text-foreground-600',
  },
];

export default function ForPartners() {
  return (
    <section id="partners" className="relative py-20 md:py-28 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14 md:mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-50 border border-accent-200/50 text-xs font-semibold tracking-wider uppercase text-accent-700 mb-5">
            Partner With Us
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight max-w-3xl mx-auto" style={{ color: '#111827' }}>
            Grow With Australia&rsquo;s
            <span className="relative ml-2" style={{ color: '#F4D13D' }}>
              Renewable Energy Marketplace
            </span>
          </h2>
          <p className="mt-4 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto">
            AK Energy helps manufacturers, installers, finance providers and retailers reach better-qualified customers through a scalable digital platform.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6 mb-12">
          {partners.map((p, i) => (
            <div
              key={p.title}
              className={`group ${p.color} rounded-2xl p-6 md:p-7 transition-all duration-300 hover:-translate-y-1 cursor-default border border-transparent hover:border-background-200`}
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className={`w-11 h-11 rounded-xl ${p.iconBg} flex items-center justify-center mb-4`}>
                <i className={`${p.icon} ${p.iconColor} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-2">{p.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="#contact"
            className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold rounded-xl border-2 border-foreground-800 text-foreground-800 hover:bg-foreground-800 hover:text-white transition-all duration-200 cursor-pointer"
          >
            Become an AK Energy Partner
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}